import React, { useEffect, useRef } from 'react'
import Header from '../layouts/Header'
import Footer from '../layouts/Footer'
import ProjectStats from '../layouts/ProjectStats'
import Responsive from '../layouts/Responsive'
import Grow from '../layouts/Grow'
import AnimationImage from '../layouts/AnimationImage'
import Service from '../layouts/Service'
import Getintouch from '../layouts/Getintouch'
import Map from '../layouts/Map'
import banner1 from '../../assets/images/banner-1.png';
import banner2 from '../../assets/images/banner-2.png';
import banner3 from '../../assets/images/banner-3.png';
import banner4 from '../../assets/images/banner-4.png';
import banner5 from '../../assets/images/banner-5.png';
import banner6 from '../../assets/images/banner-6.png';
import Next from '../../assets/images/next.png';
import { Link } from 'react-router-dom'
import Testimonial from '../layouts/Testimonial'
import WhySlider from '../layouts/WhySlider'

const Home = () => {
    const typingTextRef = useRef(null);
    const cursorRef = useRef(null);
   const steps = [
    {
        title: 'Requirements Gathering',
        description: 'We spend time on research to find what best suits to your need and to achieve your goals.',
        icon: process.env.PUBLIC_URL + '/images/work1.png',
        color: 'cyan',
    },
    {
        title: 'Planning and Strategy',
        description: 'Our team works on design starting from wireframes to design aesthetics, UX personas, UI and a lot more to build an amazing UI layout.',
        icon: process.env.PUBLIC_URL + '/images/work2.png',
        color: 'orange',
    },
    {
        title: 'Design and Development',
        description: 'Our Mobile and Web Dev team will make the designs functional under a close watch from QA team.',
        icon: process.env.PUBLIC_URL + '/images/work3.png',
        color: 'blue',
    },
    {
        title: 'Testing and Deployment',
        description: 'Once we build preview and test, we not just Deliver but continue our journey with your success and growth.',
        icon: process.env.PUBLIC_URL + '/images/work4.png',
        color: 'gray',
    },
];
    useEffect(() => {
        const typingText = typingTextRef.current;
        const cursor = cursorRef.current;
        if (!typingText || !cursor) return;

        const words = ["Designer", "Web Developer", "App Developer"];
        let wordIndex = 0,
            charIndex = 0,
            isDeleting = false;
        const typingSpeed = 100,
            deletingSpeed = 50,
            pauseBetweenWords = 1000;

        const type = () => {
            const currentWord = words[wordIndex % words.length];

            if (!isDeleting) {
                typingText.textContent = currentWord.substring(0, charIndex + 1);
                charIndex++;
                if (charIndex === currentWord.length) {
                    setTimeout(() => {
                        isDeleting = true;
                        type();
                    }, pauseBetweenWords);
                    return;
                }
            } else {
                typingText.textContent = currentWord.substring(0, charIndex - 1);
                charIndex--;
                if (charIndex === 0) {
                    isDeleting = false;
                    wordIndex++;
                }
            }
            setTimeout(type, isDeleting ? deletingSpeed : typingSpeed);
        };

        type();

        // Optional: Cursor blink animation (toggle visibility)
        let visible = true;
        const cursorInterval = setInterval(() => {
            if (cursor) {
                cursor.style.visibility = visible ? "visible" : "hidden";
                visible = !visible;
            }
        }, 500);


        return () => clearInterval(cursorInterval); // cleanup on unmount
    }, []);
    return (
        <div>
            <Header />

            <section className="banner">
                <div className="overlay"></div>

                <div>
                    <img src={banner1} className="banner-icon icon1" alt="Decoration icon" />
                    <img src={banner2} className="banner-icon icon2" alt="Decoration icon" />
                    <img src={banner3} className="banner-icon icon3" alt="Decoration icon" />
                    <img src={banner4} className="banner-icon icon4" alt="Decoration icon" />
                    <img src={banner5} className="banner-icon icon5" alt="Decoration icon" />
                    <img src={banner6} className="banner-icon icon6" alt="Decoration icon" />
                </div>

                <div className="banner-div">
                    <h1>
                        Modern Web & <br /> App Engineering
                    </h1>

                    <h2 className="typing-container">
                        <span className="typing-text" ref={typingTextRef}></span>
                        <span className="cursor" ref={cursorRef}>
                            |
                        </span>
                    </h2>

                    <div className="banner-button">
                        <a href="/contact" className="banner-btn-1">Contact Us</a>
                        <a href="/about" className="banner-btn-1">About Us</a>
                    </div>

                    <p className="banner-text-p">Your one-stop web/app solution hub</p>
                </div>
            </section>

            <section className="next">
                <div className="next-div1">
                    <h2 className="next-text-2">
                        We are Developers that help you to make digital impact
                    </h2>
                    <p className="next-text-p">
                        We Craft Powerful Digital Experiences Design. Development. Done Right.
                    </p>
                    <Link className="next-button">Watch Us</Link>

                </div>
                <div className="next-div2">
                    <img src={Next} className="next-image" alt="Developers working" />
                </div>
            </section>

            <ProjectStats />

            <Responsive />

            <section className="how-we-work">
                <div className="container">
                    <h2>How We Work ?</h2>
                    <p className="subtitle">
                        We mix creativity, clean code, and strategic thinking into a powerful, end-to-end process that transforms ideas
                        into high-performing digital solutions.
                    </p>

                    <div className="steps">
                        {steps.map((step, index) => (
                            <div className="step-box" key={index}>
                                <div className={`icon-box ${step.color}`}>
                                    <img src={step.icon} alt={step.title} />
                                </div>
                                <h3>{step.title}</h3>
                                <p>{step.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <WhySlider />

            <AnimationImage />

            <div class="service">
                <h2>
                    Here is how Code Buddy's <br />Can Help you
                </h2>
                <Service />
            </div>

            <Grow />

            <Testimonial />

            <Getintouch />

            <Map />

            <Footer />
        </div>
    )
}

export default Home